import * as types from './Types.js';

export function findHomologacao(
  entidade,
  exercicio,
  exercicioLicitacao,
  tipoLicitacao,
  licitacao,
  pessoa
) {
  return ({ fetch }) => ({
    type: types.HOMOLOGACAO,
    payload: {
      promise: fetch(
        `/api/homologacoes/detalhes?entidade=${entidade}&exercicio=${exercicio}&exercicioLicitacao=${exercicioLicitacao}&tipoLicitacao=${tipoLicitacao}&licitacao=${licitacao}&pessoa=${pessoa}`
      )
    }
  });
}

export function findArquivos(
  entidade,
  exercicio,
  exercicioLicitacao,
  tipoLicitacao,
  licitacao,
  pessoa
) {
  return ({ fetch }) => ({
    type: types.HOMOLOGACAO_ARQUIVOS,
    payload: {
      promise: fetch(
        `/api/homologacoes/arquivos?entidade=${entidade}&exercicio=${exercicio}&exercicioLicitacao=${exercicioLicitacao}&tipoLicitacao=${tipoLicitacao}&licitacao=${licitacao}&pessoa=${pessoa}`
      )
    }
  });
}
